import moment from 'moment';
import { formatDisplayDayMonth, formatNumber } from '../../../shared/i18n/locale';

/** Formatting helper for plan date ranges with locale-aware month names and digit-aware day/year. */
export function getFormattedPlanRange(start: string, end: string, locale: string): string {
  const formats = ['YYYY-MM-DD', 'DD MMMM, YYYY'];
  const start_moment = moment(start, formats, true);
  const end_moment = moment(end, formats, true);

  if (!start_moment.isValid() || !end_moment.isValid()) {
    return `${start} – ${end}`;
  }

  const active_locale = locale === 'ar' ? 'ar' : 'en';
  const prev = moment.locale();
  try {
    moment.locale(active_locale);
  } catch {
    moment.locale('en');
  }
  try {
    const fmt = (m: moment.Moment) =>
      `${formatNumber(m.date())} ${m.format('MMM')} ${formatNumber(m.year(), { useGrouping: false })}`;
    return `${fmt(start_moment)} – ${fmt(end_moment)}`;
  } finally {
    try {
      moment.locale(prev);
    } catch {
      // ignore
    }
  }
}

export function getTodayDateLabel(_locale: string): string {
  return formatDisplayDayMonth(moment(), true);
}
